<capra-icon-button
  class="container-button {{ theme }}"
  [class.analyst-studio]="isAnalystStudio$ | async"
  [size]="(isAnalystStudio$ | async) === true ? 'x-large' : 'medium'"
  icon="icon-plus-global"
  [matMenuTriggerFor]="menu"
  aria-label="Create new report or dataset menu trigger"
  data-test="green-plus-button"
></capra-icon-button>

<mat-menu class="menu container-menu-panel" #menu="matMenu" xPosition="before" (closed)="(null)">
    <h3 class="title">Reporting</h3>
    <ng-container *ngFor="let menuItem of menuItems; trackBy: trackByFn">
      <mode-report-creation-menu-item
        *ngIf="optionCategoryRecord?.[menuItem.testAttribute] === 'reporting'"
        [item]="menuItem"
      ></mode-report-creation-menu-item>
    </ng-container>

    <hr class="divider" />

    <h3 class="title">Datasets</h3>
    <ng-container *ngFor="let menuItem of menuItems; trackBy: trackByFn">
      <mode-report-creation-menu-item
        *ngIf="optionCategoryRecord?.[menuItem.testAttribute] === 'datasets'"
        [item]="menuItem"
        (clicked)="onClick($event, menuItem.testAttribute)"
      ></mode-report-creation-menu-item>
    </ng-container>
</mat-menu>
